import React from 'react';

const ConfirmIcon = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <polygon
          points="418.1,48.9 373.1,95.9 191.8,277.2 138.9,226.3 91.9,179.4 0,271.3 46.9,318.3 144.8,416.1 189.8,463.1 
		236.8,416.1 465.1,187.8 512,140.9 	"
        />
      </g>
    </svg>
  );
};

export default ConfirmIcon;
